const link = {
    label: 'Link',
    name: 'link',
    widget: 'object',
    fields: [
        {
            label: 'Name',
            name: 'name',
            widget: 'string',
            default: '',
        },
        {
            label: 'URL',
            name: 'url',
            widget: 'string',
            default: '',
        },
    ],
}


export default {
    file: 'src/content/pages/404.json',
    label: '404',
    name: '404',
    i18n : true,
    fields: [
        {
            label: 'Title',
            name: 'title',
            widget: 'string',
            default: '',
            i18n: true,
            required: true,
        },
        {
            label: 'Description',
            name: 'description',
            widget: 'string',
            default: '',
            i18n: true,
            required: true,
        },
        {
            label: 'Links',
            name: 'links',
            widget: 'list',
            i18n: true,
            types: [link]
        }
    ]
    
}